module.exports = __webpack_public_path__ + "img/Send-money.b29ef781.png";